import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Typography, Card } from '@mui/material';

import { Page } from '@occc-app/design-system';
import config from '@occc/config';

import { routeCreator } from '../retailer-connect.utils';
import { withRetailerNetwork, WithRetailerNetworkProps } from '../hocs/with-retailer-network.hoc';
import { useBreadcrumbLinks } from '../hooks/use-breadcrumb-links.hook';

const PAGE_TITLE = 'Store Details';

const RetailerNetworkMyStoresStorePage = ({ retailerNetwork }: WithRetailerNetworkProps) => {
  const { storeId } = useParams<{ storeId: string }>();

  const [breadcrumbLinks] = useState(() => [
    { label: 'My Stores', to: routeCreator.myStores(retailerNetwork.uuid) },
    { label: PAGE_TITLE },
  ]);

  useBreadcrumbLinks(breadcrumbLinks);

  return (
    <Page
      browserTabTitle={PAGE_TITLE}
      pageHeaderProps={{
        title: PAGE_TITLE,
        titleTestId: 'rc-store-title',
        subtitle: `${config.brandName} Brand. Page in progress...`,
      }}
      containerProps={{ variant: 'md' }}
    >
      <Card>
        <Typography paragraph align='center' sx={{ my: 3 }}>
          Network ID: {retailerNetwork.uuid} Store ID: {storeId}
        </Typography>
      </Card>
    </Page>
  );
};

export default withRetailerNetwork(RetailerNetworkMyStoresStorePage);
